interface BreadcrumbItem {
  label: string
  to?: string
}

interface PageBreadcrumbProps {
  title: string
  /** Optional trailing breadcrumb items. Defaults to [Home, title]. */
  items?: BreadcrumbItem[]
  /** Render only the banner background, without the title and breadcrumb trail. */
  hideContent?: boolean
  /** Slimmer banner height. */
  compact?: boolean
}

/**
 * Exact reproduction of the template breadcrumb section (about.html / services.html ...).
 * Crumb items with a `to` render as links; the last item is always the active page.
 */
export function PageBreadcrumb({ title, items, hideContent, compact }: PageBreadcrumbProps) {
  const crumbs: BreadcrumbItem[] = items ?? [{ label: 'Home', to: '/' }, { label: title }]
  const lastIndex = crumbs.length - 1

  return (
    <section
      className={`breadcrumb-section${compact ? ' breadcrumb-section--compact' : ''}`}
      style={{ backgroundImage: 'url(/assets/images/breadcrumb/breadcrumb.png)' }}
    >
      {!hideContent && (
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-content">
                <div className="breadcrumb-title wow fadeInUp" data-wow-delay=".2s">
                  <h1>{title}</h1>
                </div>
                <nav aria-label="breadcrumb" className="wow fadeInUp" data-wow-delay=".3s">
                  <ol className="breadcrumb">
                    {crumbs.map((crumb, index) => {
                      const isLast = index === lastIndex
                      return (
                        <li
                          key={`${crumb.label}-${index}`}
                          className={`breadcrumb-item${isLast ? ' active' : ''}`}
                          aria-current={isLast ? 'page' : undefined}
                        >
                          {crumb.to && !isLast ? <a href={crumb.to}>{crumb.label}</a> : crumb.label}
                        </li>
                      )
                    })}
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="breadcrumb-shape">
        <img className="breadcrumb-shape-one" src="/assets/images/shape/shape-4.png" alt="breadcrumb shape one" />
        <img className="breadcrumb-shape-two" src="/assets/images/shape/square-blue.png" alt="breadcrumb shape two" />
        <img className="breadcrumb-shape-three" src="/assets/images/shape/plus-orange.png" alt="breadcrumb shape three" />
      </div>
    </section>
  )
}
